@use '../../styles/variables.scss';
@use '../../styles/breakpoints.scss';

.page {
  padding-top: 2rem;
  padding-bottom: 2rem;
  font-size: 20px; // alt skal være 20px utenom overskrifter, eller annet som er definert annet
}
